<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        dataRowTemplate="dataRowTemplateName"
        [allowColumnResizing]="false"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
        <dxi-column dataField="NO_OF_TRIPS" caption="No.of Trips"></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Bus. Grp"> </dxi-column>
        <dxi-column dataField="cust_name" caption="Consignee"> </dxi-column>
        <dxi-column dataField="origin_city" caption="Origin"> </dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column caption="Outbound" alignment="center">
            <dxi-column dataField="OUT_ACT_HRS" caption="Act Hrs"></dxi-column>
            <dxi-column dataField="OUT_REQ_HRS" caption="Rqst Hrs"></dxi-column>
            <dxi-column dataField="OUT_VAR_HRS" caption="Var Hrs"></dxi-column>
        </dxi-column>
        <dxi-column dataField="late_trips" caption="Late #"></dxi-column>
        <dxi-column dataField="late_percent" caption="Late %"></dxi-column>
        <dxi-column dataField="early_trips" caption="Early #"></dxi-column>
        <dxi-column dataField="early_percent" caption="Early %"></dxi-column>
        <ng-container *dxTemplate="let item of 'dataRowTemplateName'">
            <tr class="main-row" (dblclick)="openTrips(item.data)">
                <td>{{ item.data.NO_OF_TRIPS }}</td>
                <td>{{ item.data.fleet_id }}</td>
                <td>{{ item.data.business_group }}</td>
                <td>{{ item.data.cust_no }} {{ item.data.cust_name }}</td>
                <td>{{ item.data.origin_city }} {{ item.data.origin_state }}</td>
                <td>{{ item.data.dest_city }} {{ item.data.dest_state }}</td>
                <td>{{ item.data.OUT_ACT_HRS }}</td>
                <td>{{ item.data.OUT_REQ_HRS }}</td>
                <td>{{ item.data.OUT_VAR_HRS }}</td>
                <td>{{ item.data.late_trips }}</td>
                <td>{{ item.data.late_percent }}</td>
                <td>{{ item.data.early_trips }}</td>
                <td>{{ item.data.early_percent }}</td>
            </tr>
            <tr class="second-row" (dblclick)="openTrips(item.data)">
                <td></td>
                <td colspan="6">
                    <div>
                        <span><b>Route Dscr: </b></span>{{ item.data.route_dscr }}
                    </div>
                </td>
                <td colspan="6">
                    <div>
                        <span><b>Dlv Carrier: </b></span>{{ item.data.dlv_road }}
                    </div>
                </td>
            </tr>
        </ng-container>
    </dx-data-grid>
</div>
